const questionFeedbackContextTextTemplate = ({questionFeedbackContextText}) => `<span class="sr-only">${questionFeedbackContextText}</span>`;

export default questionFeedbackContextTextTemplate;
